import React from 'react'
import { TabPanels, TabPanel } from '@hub/tabs'
import type {
  OpenHamburgerMenuAtPathType,
  LinkItem,
  HeaderVariants,
} from '../types'
import { Centre as CentreType } from '../../../../types/centre'
import { NavLinks, NavLinksProps } from './nav-links'
import { FindACentreNavPanel } from './find-a-centre-panel'

interface TabsProps {
  variant: HeaderVariants
  centres: CentreType[]
  centre?: CentreType
  primaryLinks?: LinkItem[]
  tertiaryLinks?: LinkItem[]
  openHamburgerMenuAtPath: OpenHamburgerMenuAtPathType
}

export const UniversalHeaderTabs: React.FC<TabsProps> = ({
  variant,
  centres,
  centre,
  primaryLinks,
  tertiaryLinks,
  openHamburgerMenuAtPath,
}) => {
  const navLinksProps: NavLinksProps = {
    primaryLinks,
    tertiaryLinks,
    openHamburgerMenuAtPath,
    tabKey: 'shop',
    label: 'Shop online',
  }

  switch (variant) {
    case 'gift-cards':
      navLinksProps.tabKey = 'gift-cards'
      navLinksProps.label = 'Gift cards'
      break

    case 'centre':
      if (centre) {
        navLinksProps.tabKey = 'centre'
        navLinksProps.label = centre && centre.title
        break
      }
      break

    default:
      break
  }

  return (
    <TabPanels
      sx={{ bg: 'smoke', borderBottom: '1px', borderBottomColor: 'ghost' }}
    >
      <TabPanel tabIndex={-1} sx={{ padding: 0, height: 'size-8' }}>
        <NavLinks {...navLinksProps} />
      </TabPanel>

      {variant !== 'centre' && variant !== 'gift-cards' && (
        <TabPanel tabIndex={-1} sx={{ padding: 0, height: 'size-8' }}>
          <FindACentreNavPanel centres={centres} />
        </TabPanel>
      )}
    </TabPanels>
  )
}
